import {Injectable} from '@angular/core';
import {ExerciseModel} from '@generativ/much-smarter-models';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ErrorHandlerService} from '../../core/services/error-handler.service';
import {ExerciseRequest} from '@generativ/much-smarter-models';

@Injectable({ providedIn: 'root' })
export class ExerciseService {

  private exercisesUrl = environment.msApiUrl + 'exercises/';

  constructor(private http: HttpClient, private errorHandlerService: ErrorHandlerService) {

  }

  getExercise(id: number): Observable<ExerciseModel> {
    return this.http.get<ExerciseModel>(this.exercisesUrl + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  createExercise(exercise: ExerciseRequest.Create): Observable<ExerciseModel> {
    return this.http.post<ExerciseModel>(this.exercisesUrl, exercise).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  updateExercise(id: number, exercise: ExerciseRequest.Update): Observable<ExerciseModel> {
    return this.http.patch<ExerciseModel>(this.exercisesUrl + id, exercise).pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
